var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03705 1.5003C5.03705 1.36206 5.14898 1.25 5.28705 1.25C5.42512 1.25 5.53705 1.36206 5.53705 1.5003L5.53705 8.15387C5.54223 8.14923 5.5473 8.14442 5.55227 8.13944L6.98533 6.70469C7.08296 6.60695 7.24126 6.60695 7.33889 6.70469C7.43652 6.80244 7.43652 6.96092 7.33889 7.05866L5.90583 8.49342C5.56412 8.83553 5.0101 8.83553 4.66839 8.49342L3.23533 7.05866C3.1377 6.96092 3.1377 6.80244 3.23533 6.70469C3.33296 6.60695 3.49126 6.60695 3.58889 6.70469L5.02194 8.13944C5.02688 8.14438 5.03192 8.14916 5.03705 8.15377L5.03705 1.5003Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescIcon);
export default __webpack_public_path__ + "static/media/DescIcon.b9ca66081e2abccb05cc5d40111f6900.svg";
export { ForwardRef as ReactComponent };